import { showToast } from '@bp/ui-components';
import { CombinedError } from 'urql';

export function showErrorToast(error: CombinedError) {
  showToast(`Error - ${error.message}`, {
    type: 'error',
  });
}
